import { ref, computed, onMounted } from "vue";
import { defineStore } from "pinia";
import axios from "axios";
import { API_URL } from "@/utils/constans.js";
import { useRouter } from "vue-router";
import { useLangStore } from "@/stores/storeLang";

export const useSettingsStore = defineStore("settings", () => {

	const router = useRouter();

	const settings = ref({});

	const statusStockActive = computed(() => settings.value?.state === "active"); // активный
	const statusStockFuture = computed(() => settings.value?.state === "not_started"); // еще не начался
	const statusStockPast = computed(() => settings.value?.state === "ended"); // прошел
	const statusStockClosed = computed(() => settings.value?.state === "closed"); // закрыт
	const loaderActive = ref(false);
	const isPageLoaded = ref(false);
	const rules = ref(null);
	const hasPlayedLogoIntro = ref(localStorage.getItem("hasPlayedLogoIntro") === "1");
	const hasPlayedMainScreenIntro = ref(localStorage.getItem("hasPlayedMainScreenIntro") === "1");
	const scrollY = ref(0);
	const widthWindow = ref(window.innerWidth);
	const heightWindow = ref(window.innerHeight);

	const mainSettings = async () => {
		try {
			const lang = useLangStore().lang;
			const response = await axios.get(`${API_URL}/api/v1/promo-config`, {params: {lang}});
			settings.value = response.data;
			rules.value = response.data.rules_url
		} catch (error) {
			console.log("error:", error);
		}
	};

	const getFaq = async (lang) => {
		try {
			let url = `${API_URL}/api/v1/faq`;		
			const { data } = await axios.get(url, {params: {lang: lang}});
			return data.items;
		} catch (error) {
			console.log("getFaq:", error);
		}
	};


	const goToNexPage = (namePage) => {
		router.push({ name: namePage });
	}

	const updateWidthWindow = () => {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	};

	const resetPageLoaded = () => { isPageLoaded.value = false };
	const markPageLoaded  = () => { isPageLoaded.value = true };

	const setPlayedLogoIntro = (value) => {
		hasPlayedLogoIntro.value = value;
		localStorage.setItem("hasPlayedLogoIntro", value ? "1" : "0");
	};

	const setPlayedMainScreenIntro = (value) => {
		hasPlayedMainScreenIntro.value = value;
		localStorage.setItem("hasPlayedMainScreenIntro", value ? "1" : "0");
	};

	onMounted(() => {
		window.addEventListener("resize", updateWidthWindow);
		updateWidthWindow();
	});

	return {
		mainSettings,
		getFaq,
		setPlayedLogoIntro,
		setPlayedMainScreenIntro,
		goToNexPage,
		resetPageLoaded,
		markPageLoaded,

		settings,
		loaderActive,
		isPageLoaded,
		widthWindow,
		heightWindow,
		statusStockActive,
		statusStockFuture,
		statusStockPast,
		statusStockClosed,
		hasPlayedMainScreenIntro,
		hasPlayedLogoIntro,
		scrollY,
		rules,
	};
});
